<template>
  <el-upload ref="elUpload"
             action=""
             :limit="1"
             style="display: none;"
             :accept="accept"
             :show-file-list="false"
             :http-request="handleHttpRequest">
    <i ref="upload"></i>
  </el-upload>
</template>
<script>
const XLSX = require('xlsx')
export default {
  name: 'xls-decode-to-data',
  props: {
    callback: Function,
    action: { type: String, default: 'account/uploadfile' },
    accept: { type: String, default: '.xls,.xlsx' }
  },
  data () {
    return {
      options: {}
    }
  },
  methods: {
    handleHttpRequest ({ file }) {
      console.log(file)
      let reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onload = () => {
        let buffer = reader.result
        let bytes = new Uint8Array(buffer)
        let length = bytes.byteLength
        let binary = ''
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        let wb = XLSX.read(binary, { type: 'binary' })
        let outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
        console.log(outdata)
      }
    },
    upload (row = {}) {
      this.options = row
      this.$refs.upload.click()
    }
  }
}
</script>

<style>
</style>
